import { OlsConfigStore } from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';
import CookieBannerUtils from './CookieBannerUtils';

export const getOrderCompleteUrl = ({ number, token }) => {
  const host = OlsConfigStore.getState().olsHost;
  const parameters = `?cookie_terms_accepted=${CookieBannerUtils.isAccepted}`;

  return `${host}/orders/${number}/token/${token}${parameters}`;
};
